import React,{Component} from 'react'

class Outro extends Component{
    render(){
        return(
            <div></div>
        )
    }
}
export default Outro


// WEBPACK FOOTER //
// ./src/Outro.js